function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/* eslint @typescript-eslint/no-unused-vars: "off" */
/**
 * Handle keys in a grid
 * Return true from any of the events to indicate they're consumed, and stopPropagation/preventDefault will be called.
 */

/**
 * Some events we listen to are a native keyboard event, and others are wrapped with React's SyntheticEvent.
 * The KeyHandler shouldn't care though - the properties it accesses should be common on both types of events.
 */

export class KeyHandler {
  // What order this key handler should trigger in
  // Default to well below any of the GRID key handlers 100-1000+
  constructor() {
    var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
    _defineProperty(this, "order", void 0);
    // Cursor to use if this returns any truthy value including { stopPropagation: false, preventDefault: false }
    _defineProperty(this, "cursor", null);
    this.order = order;
  }
  /**
   * Handle a keydown event on the grid.
   * @param event The keyboard event
   * @param grid The grid component the key press is on
   * @returns Response indicating if the key was consumed
   */
  onDown(event, grid) {
    return false;
  }

  /**
   * Handle a keyup event on the grid.
   * @param event The keyboard event
   * @param grid The grid component the key press is on
   * @returns Response indicating if the key was consumed
   */
  onUp(event, grid) {
    return false;
  }
}
export default KeyHandler;
//# sourceMappingURL=KeyHandler.js.map